import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Product from '../views/product.vue'
import Products1 from '../views/Products1.vue'
import Products2 from '../views/Products2.vue'

Vue.use(VueRouter)

const routes = [{ //首页
        path: '/home',
        name: 'Home',
        component: Home,
        meta:{title: '智选云商-首页'}
    }, 
    {
        path: '/about',
        name: 'About',
        meta:{title: '智选云商-关于我们'},
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/About.vue')
    },
    { //产品
        path: '/product',
        name: 'Product',
        component: Product,      
        children: [
            {
                path: '',
                component: Products1,
                meta:{title: '智选云商-产品-零售'},
            },
            {
                path: 'products2',
                component: Products2,
                meta:{title: '智选云商-产品-分销'},
            }
        ]
    },
    { //服务
        path: '/service',
        name: 'Service',
        meta:{title: '智选云商-服务'},
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Service.vue')
    },
    { //价格
        path: '/price',
        meta:{title: '智选云商-价格'},
        name: 'Price',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/Price.vue')
    },
    { //说明
        path: '/program',
        meta:{title: '智选云商-营销方案'},
        name: 'program',
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/program.vue')
    },
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '*',
        redirect: '/home'
    }

]

const router = new VueRouter({
    // mode: 'hash',
    // mode: 'history',
    routes
})

export default router